<!--
  QUnit reports
     <ActionDownloadEvidence
       :size='small'
       :unit="QUnit"
       :color="primary"
       :loading=false
     />
-->

<template>
  <div class="vcenter" v-if="show_action">
    <v-progress-circular
      v-if="loading"
      indeterminate
      :color="color"
      :size="size == 'small' ? 20 : 30"
    />
    <v-menu 
      v-else
      top
      offset-y
      content-class="qmkey-explorer-table-menu-contents"
      :disabled="disabled || !unit.reports || !unit.reports.length >0"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-icon
          :color="color"
          :small="size == 'small'"
          :large="size == 'large'"
          v-on="on"
          v-bind="attrs"
          :disabled="disabled"
          @click="click"
        >
        {{ 'mdi-printer' }}
        </v-icon>
        <!-- TODO change me again when icon {{ 'mdi-printer-outline' }}-->
      </template>

      <v-list dense>
        <v-list-item
          v-for="report in unit.reports"
          :key="report.value"
          @click.stop="print_unit(report)"
        >
          <v-list-item-title>{{ report.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>


<script>
import { downloadFile } from '@/utils/browserfiles';
import QReport from '@/api/QReportsItem';

export default {
  // TODO: Change component name
  name: "ActionDownloadEvidence",

  props: {
    size: { default: 'small' },
    unit: { required: true },
    color: {type: String, default:"primary"},
    loading: {type: Boolean, default: false},
    disabled: Boolean
  },

  computed: {
    show_action() {
      // return (unit.reports && unit.reports.length >0);
      return (this.unit.reports||[]).length > 0;
    },
  },

  methods: {
    async print_unit(props) {
      this.$emit('loading_start');
      const unit = this.unit;
      const suffix = props.suffix ? props.suffix : "docx"
      const data = await QReport.printQUnit(unit._protected.centro, unit.uid, props.value);
      this.$emit('loading_stop');
      const f_name = unit.title + suffix || unit.title + suffix;
      downloadFile(data, f_name);
    },

    click() {
      this.$emit('clicked');
    },
  },
};
</script>
